!(function (e, t) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = t(
        require("knockout"),
        require("jquery"),
        require("moment"),
        require("entities"),
        require("lodash"),
        require("settings"),
        require("spin.js"),
        require("history"),
        require("signals"),
        require("crossroads"),
        require("knockout.validation")
      ))
    : "function" == typeof define && define.amd
    ? define(
        [
          "knockout",
          "jquery",
          "moment",
          "entities",
          "lodash",
          "settings",
          "spin.js",
          "history",
          "signals",
          "crossroads",
          "knockout.validation",
        ],
        t
      )
    : "object" == typeof exports
    ? (exports.PortalFramework = t(
        require("knockout"),
        require("jquery"),
        require("moment"),
        require("entities"),
        require("lodash"),
        require("settings"),
        require("spin.js"),
        require("history"),
        require("signals"),
        require("crossroads"),
        require("knockout.validation")
      ))
    : (e.PortalFramework = t(
        e.knockout,
        e.jquery,
        e.moment,
        e.entities,
        e.lodash,
        e.settings,
        e["spin.js"],
        e.history,
        e.signals,
        e.crossroads,
        e["knockout.validation"]
      ));
})(window, function (n, o, r, i, a, s, u, l, c, f, d) {
  return (
    (m = {}),
    (p.m = h =
      [
        function (e, t) {
          e.exports = n;
        },
        function (e, t) {
          e.exports = o;
        },
        function (e, t) {
          e.exports = r;
        },
        function (e, t) {
          e.exports = i;
        },
        function (e, t) {
          e.exports = a;
        },
        function (e, l, t) {
          (function (r) {
            function i(e, t) {
              for (var n = 0, o = e.length - 1; 0 <= o; o--) {
                var r = e[o];
                "." === r ? e.splice(o, 1) : ".." === r ? (e.splice(o, 1), n++) : n && (e.splice(o, 1), n--);
              }
              if (t) for (; n--; ) e.unshift("..");
              return e;
            }

            function a(e, t) {
              if (e.filter) return e.filter(t);
              for (var n = [], o = 0; o < e.length; o++) t(e[o], o, e) && n.push(e[o]);
              return n;
            }
            (l.resolve = function () {
              for (var e = "", t = !1, n = arguments.length - 1; -1 <= n && !t; n--) {
                var o = 0 <= n ? arguments[n] : r.cwd();
                if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
                o && ((e = o + "/" + e), (t = "/" === o.charAt(0)));
              }
              return (
                (t ? "/" : "") +
                  (e = i(
                    a(e.split("/"), function (e) {
                      return !!e;
                    }),
                    !t
                  ).join("/")) || "."
              );
            }),
              (l.normalize = function (e) {
                var t = l.isAbsolute(e),
                  n = "/" === o(e, -1);
                return (
                  (e = i(
                    a(e.split("/"), function (e) {
                      return !!e;
                    }),
                    !t
                  ).join("/")) ||
                    t ||
                    (e = "."),
                  e && n && (e += "/"),
                  (t ? "/" : "") + e
                );
              }),
              (l.isAbsolute = function (e) {
                return "/" === e.charAt(0);
              }),
              (l.join = function () {
                var e = Array.prototype.slice.call(arguments, 0);
                return l.normalize(
                  a(e, function (e, t) {
                    if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
                    return e;
                  }).join("/")
                );
              }),
              (l.relative = function (e, t) {
                function n(e) {
                  for (var t = 0; t < e.length && "" === e[t]; t++);
                  for (var n = e.length - 1; 0 <= n && "" === e[n]; n--);
                  return n < t ? [] : e.slice(t, n - t + 1);
                }
                (e = l.resolve(e).substr(1)), (t = l.resolve(t).substr(1));
                for (
                  var o = n(e.split("/")), r = n(t.split("/")), i = Math.min(o.length, r.length), a = i, s = 0;
                  s < i;
                  s++
                )
                  if (o[s] !== r[s]) {
                    a = s;
                    break;
                  }
                var u = [];
                for (s = a; s < o.length; s++) u.push("..");
                return (u = u.concat(r.slice(a))).join("/");
              }),
              (l.sep = "/"),
              (l.delimiter = ":"),
              (l.dirname = function (e) {
                if (("string" != typeof e && (e += ""), 0 === e.length)) return ".";
                for (var t = e.charCodeAt(0), n = 47 === t, o = -1, r = !0, i = e.length - 1; 1 <= i; --i)
                  if (47 === (t = e.charCodeAt(i))) {
                    if (!r) {
                      o = i;
                      break;
                    }
                  } else r = !1;
                return -1 === o ? (n ? "/" : ".") : n && 1 === o ? "/" : e.slice(0, o);
              }),
              (l.basename = function (e, t) {
                var n = (function (e) {
                  "string" != typeof e && (e += "");
                  var t,
                    n = 0,
                    o = -1,
                    r = !0;
                  for (t = e.length - 1; 0 <= t; --t)
                    if (47 === e.charCodeAt(t)) {
                      if (!r) {
                        n = t + 1;
                        break;
                      }
                    } else -1 === o && ((r = !1), (o = t + 1));
                  return -1 === o ? "" : e.slice(n, o);
                })(e);
                return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
              }),
              (l.extname = function (e) {
                "string" != typeof e && (e += "");
                for (var t = -1, n = 0, o = -1, r = !0, i = 0, a = e.length - 1; 0 <= a; --a) {
                  var s = e.charCodeAt(a);
                  if (47 === s) {
                    if (r) continue;
                    n = a + 1;
                    break;
                  }
                  -1 === o && ((r = !1), (o = a + 1)),
                    46 === s ? (-1 === t ? (t = a) : 1 !== i && (i = 1)) : -1 !== t && (i = -1);
                }
                return -1 === t || -1 === o || 0 === i || (1 === i && t === o - 1 && t === n + 1) ? "" : e.slice(t, o);
              });
            var o =
              "b" === "ab".substr(-1)
                ? function (e, t, n) {
                    return e.substr(t, n);
                  }
                : function (e, t, n) {
                    return t < 0 && (t = e.length + t), e.substr(t, n);
                  };
          }).call(this, t(7));
        },
        function (e, t) {
          var n;
          n = (function () {
            return this;
          })();
          try {
            n = n || new Function("return this")();
          } catch (e) {
            "object" == typeof window && (n = window);
          }
          e.exports = n;
        },
        function (e, t) {
          var n,
            o,
            r = (e.exports = {});

          function i() {
            throw new Error("setTimeout has not been defined");
          }

          function a() {
            throw new Error("clearTimeout has not been defined");
          }

          function s(t) {
            if (n === setTimeout) return setTimeout(t, 0);
            if ((n === i || !n) && setTimeout) return (n = setTimeout), setTimeout(t, 0);
            try {
              return n(t, 0);
            } catch (e) {
              try {
                return n.call(null, t, 0);
              } catch (e) {
                return n.call(this, t, 0);
              }
            }
          }
          !(function () {
            try {
              n = "function" == typeof setTimeout ? setTimeout : i;
            } catch (e) {
              n = i;
            }
            try {
              o = "function" == typeof clearTimeout ? clearTimeout : a;
            } catch (e) {
              o = a;
            }
          })();
          var u,
            l = [],
            c = !1,
            f = -1;

          function d() {
            c && u && ((c = !1), u.length ? (l = u.concat(l)) : (f = -1), l.length && p());
          }

          function p() {
            if (!c) {
              var e = s(d);
              c = !0;
              for (var t = l.length; t; ) {
                for (u = l, l = []; ++f < t; ) u && u[f].run();
                (f = -1), (t = l.length);
              }
              (u = null),
                (c = !1),
                (function (t) {
                  if (o === clearTimeout) return clearTimeout(t);
                  if ((o === a || !o) && clearTimeout) return (o = clearTimeout), clearTimeout(t);
                  try {
                    o(t);
                  } catch (e) {
                    try {
                      return o.call(null, t);
                    } catch (e) {
                      return o.call(this, t);
                    }
                  }
                })(e);
            }
          }

          function h(e, t) {
            (this.fun = e), (this.array = t);
          }

          function m() {}
          (r.nextTick = function (e) {
            var t = new Array(arguments.length - 1);
            if (1 < arguments.length) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
            l.push(new h(e, t)), 1 !== l.length || c || s(p);
          }),
            (h.prototype.run = function () {
              this.fun.apply(null, this.array);
            }),
            (r.title = "browser"),
            (r.browser = !0),
            (r.env = {}),
            (r.argv = []),
            (r.version = ""),
            (r.versions = {}),
            (r.on = m),
            (r.addListener = m),
            (r.once = m),
            (r.off = m),
            (r.removeListener = m),
            (r.removeAllListeners = m),
            (r.emit = m),
            (r.prependListener = m),
            (r.prependOnceListener = m),
            (r.listeners = function (e) {
              return [];
            }),
            (r.binding = function (e) {
              throw new Error("process.binding is not supported");
            }),
            (r.cwd = function () {
              return "/";
            }),
            (r.chdir = function (e) {
              throw new Error("process.chdir is not supported");
            }),
            (r.umask = function () {
              return 0;
            });
        },
        function (e, t) {
          e.exports = s;
        },
        function (e, t) {
          e.exports = u;
        },
        function (e, t) {
          e.exports = l;
        },
        function (e, t) {
          e.exports = c;
        },
        function (e, r, i) {
          (function (e) {
            var t = (void 0 !== e && e) || ("undefined" != typeof self && self) || window,
              n = Function.prototype.apply;

            function o(e, t) {
              (this._id = e), (this._clearFn = t);
            }
            (r.setTimeout = function () {
              return new o(n.call(setTimeout, t, arguments), clearTimeout);
            }),
              (r.setInterval = function () {
                return new o(n.call(setInterval, t, arguments), clearInterval);
              }),
              (r.clearTimeout = r.clearInterval =
                function (e) {
                  e && e.close();
                }),
              (o.prototype.unref = o.prototype.ref = function () {}),
              (o.prototype.close = function () {
                this._clearFn.call(t, this._id);
              }),
              (r.enroll = function (e, t) {
                clearTimeout(e._idleTimeoutId), (e._idleTimeout = t);
              }),
              (r.unenroll = function (e) {
                clearTimeout(e._idleTimeoutId), (e._idleTimeout = -1);
              }),
              (r._unrefActive = r.active =
                function (e) {
                  clearTimeout(e._idleTimeoutId);
                  var t = e._idleTimeout;
                  0 <= t &&
                    (e._idleTimeoutId = setTimeout(function () {
                      e._onTimeout && e._onTimeout();
                    }, t));
                }),
              i(15),
              (r.setImmediate =
                ("undefined" != typeof self && self.setImmediate) ||
                (void 0 !== e && e.setImmediate) ||
                (this && this.setImmediate)),
              (r.clearImmediate =
                ("undefined" != typeof self && self.clearImmediate) ||
                (void 0 !== e && e.clearImmediate) ||
                (this && this.clearImmediate));
          }).call(this, i(6));
        },
        function (e, t) {
          e.exports = f;
        },
        function (e, t) {
          e.exports = d;
        },
        function (e, t, n) {
          (function (e, h) {
            !(function (n, o) {
              "use strict";
              if (!n.setImmediate) {
                var r,
                  i,
                  t,
                  a,
                  s = 1,
                  u = {},
                  l = !1,
                  c = n.document,
                  e = Object.getPrototypeOf && Object.getPrototypeOf(n);
                (e = e && e.setTimeout ? e : n),
                  (r =
                    "[object process]" === {}.toString.call(n.process)
                      ? function (e) {
                          h.nextTick(function () {
                            d(e);
                          });
                        }
                      : (function () {
                          if (n.postMessage && !n.importScripts) {
                            var e = !0,
                              t = n.onmessage;
                            return (
                              (n.onmessage = function () {
                                e = !1;
                              }),
                              n.postMessage("", "*"),
                              (n.onmessage = t),
                              e
                            );
                          }
                        })()
                      ? ((a = "setImmediate$" + Math.random() + "$"),
                        n.addEventListener ? n.addEventListener("message", p, !1) : n.attachEvent("onmessage", p),
                        function (e) {
                          n.postMessage(a + e, "*");
                        })
                      : n.MessageChannel
                      ? (((t = new MessageChannel()).port1.onmessage = function (e) {
                          d(e.data);
                        }),
                        function (e) {
                          t.port2.postMessage(e);
                        })
                      : c && "onreadystatechange" in c.createElement("script")
                      ? ((i = c.documentElement),
                        function (e) {
                          var t = c.createElement("script");
                          (t.onreadystatechange = function () {
                            d(e), (t.onreadystatechange = null), i.removeChild(t), (t = null);
                          }),
                            i.appendChild(t);
                        })
                      : function (e) {
                          setTimeout(d, 0, e);
                        }),
                  (e.setImmediate = function (e) {
                    "function" != typeof e && (e = new Function("" + e));
                    for (var t = new Array(arguments.length - 1), n = 0; n < t.length; n++) t[n] = arguments[n + 1];
                    var o = {
                      callback: e,
                      args: t,
                    };
                    return (u[s] = o), r(s), s++;
                  }),
                  (e.clearImmediate = f);
              }

              function f(e) {
                delete u[e];
              }

              function d(e) {
                if (l) setTimeout(d, 0, e);
                else {
                  var t = u[e];
                  if (t) {
                    l = !0;
                    try {
                      !(function (e) {
                        var t = e.callback,
                          n = e.args;
                        switch (n.length) {
                          case 0:
                            t();
                            break;
                          case 1:
                            t(n[0]);
                            break;
                          case 2:
                            t(n[0], n[1]);
                            break;
                          case 3:
                            t(n[0], n[1], n[2]);
                            break;
                          default:
                            t.apply(o, n);
                        }
                      })(t);
                    } finally {
                      f(e), (l = !1);
                    }
                  }
                }
              }

              function p(e) {
                e.source === n && "string" == typeof e.data && 0 === e.data.indexOf(a) && d(+e.data.slice(a.length));
              }
            })("undefined" == typeof self ? (void 0 === e ? this : e) : self);
          }).call(this, n(6), n(7));
        },
        function (e, t, n) {
          "use strict";
          n.r(t);
          var d = n(0),
            u = n(2),
            a =
              (n(14),
              function () {
                var r = this;
                (this.load = function (o) {
                  return new Promise(function (t, e) {
                    r.file = o;
                    var n = new FileReader();
                    n.readAsDataURL(o),
                      (n.onload = function (e) {
                        r.filedata(e.target.result), t(r);
                      });
                  });
                }),
                  (this.isUploaded = d.observable(!1)),
                  (this.isUploading = d.observable(!0)),
                  (this.uploadProgress = d.observable(0)),
                  (this.filedata = d.observable());
              });

          function l(e, t) {
            var n = t;
            return (
              "date" == e
                ? (n = "YYYY-MM-DD")
                : "datetime-local" == e || "datetime" == e
                ? (n = "YYYY-MM-DDTHH:mm")
                : "month" == e
                ? (n = "YYYY-MM")
                : "time" == e
                ? (n = "HH:mm")
                : "week" == e && (n = "GGGG-[W]WW"),
              n
            );
          }
          d.bindingHandlers.date = {
            init: function (i, a, s) {
              i.onchange = function () {
                var e,
                  t = a(),
                  n = s().dateFormat ? d.utils.unwrapObservable(s().dateFormat) : "L";
                if ("INPUT" == i.tagName) {
                  var o = i.type;
                  if (((n = l(o, n)), (e = u(i.value, n)), "date" == o || "month" == o || "week" == o)) {
                    var r = u();
                    e.hour(r.hour()),
                      e.minute(r.minute()),
                      e.second(r.second()),
                      ("month" != o && "week" != o) || e.date(r.date());
                  }
                } else e = u(i.textContent, n);
                e
                  ? "function" == typeof t
                    ? t(e.toDate())
                    : t instanceof Date
                    ? t.setTime(e.toDate().getTime())
                    : (t = e.toDate())
                  : "function" == typeof t
                  ? t(null)
                  : t instanceof Date
                  ? t.setTime(0)
                  : (t = null);
              };
            },
            update: function (t, e, n, o) {
              var r = e(),
                i = d.utils.unwrapObservable(r);
              if (i) {
                var a = function () {
                    var e = n().dateFormat ? d.utils.unwrapObservable(n().dateFormat) : "L";
                    "INPUT" == t.tagName
                      ? i instanceof Date && 0 === i.getTime()
                        ? (t.value = "")
                        : ((e = l(t.type, e)), (t.value = u(i).format(e)))
                      : (t.textContent = u(i).format(e));
                  },
                  s = i.setTime;
                (i.setTime = function (e) {
                  s.apply(i, arguments), a();
                }),
                  a();
              }
            },
          };
          var c = n(1);
          (d.bindingHandlers.expand = {
            init: function (t, e, n, o, r) {
              var i = e(),
                a = d.unwrap(i.content);
              d.unwrap(i.isCollapsed);
              if ((console.log(c(i.content).outerHeight()), 60 < c(i.content).outerHeight())) {
                c(a).addClass("collapsed"),
                  i.isCollapsed.subscribe(function (e) {
                    console.log(e),
                      e
                        ? (c(a).removeClass("expanded"), c(a).addClass("collapsed"), c(t).text("Expand"))
                        : (c(a).removeClass("collapsed"), c(a).addClass("expanded"), c(t).text("Collapse"));
                  }),
                  c(t).click(function () {
                    return i.isCollapsed(!i.isCollapsed()), !1;
                  });
              } else c(t).hide();
            },
            update: function (e, t, n, o, r) {
              var i = t();
              d.unwrap(i.content);
            },
          }),
            (d.bindingHandlers.pageNum = {
              init: function (e, t, n, o, r) {},
              update: function (e, t, n, o, r) {
                var i = d.unwrap(t());
                console.log("pagenum: " + i), console.log(i), c(e).text(parseInt(i) + 1);
              },
            }),
            (d.bindingHandlers.humanDate = {
              init: function (e, t, n, o, r) {},
              update: function (e, t, n, o, r) {
                var i = d.unwrap(t());
                return u(i).fromNow();
              },
            }),
            (d.bindingHandlers.lookupDescription = {
              init: function (e, t, n, o, r) {},
              update: function (e, t, n, o, r) {
                var i = t(),
                  a = d.unwrap(i.lookup),
                  s = d.unwrap(i.name),
                  u = d.unwrap(i.value);
                c(e).text(a(s, u) || u);
              },
            }),
            (d.bindingHandlers.lookup = {
              init: function (e, t, n, o, r) {
                var i = t(),
                  a = {
                    options: d.unwrap(i.lookup)(d.unwrap(i.name)),
                    optionsText: n.get("optionsText"),
                    optionsValue: n.get("optionsValue"),
                    value: n.get("value"),
                    optionsCaption: n.get("optionsCaption"),
                  };
                d.applyBindingsToNode(e, a, o);
              },
              update: function (e, t, n, o, r) {},
            }),
            (d.bindingHandlers.upload = {
              init: function (e, t, n, o, r) {},
              update: function (e, t, n, o, r) {
                var i = t();
                d.unwrap(i.entity), i.property;
                c(e).on("change", function (e) {
                  var t = e.target.files[0];
                  new a()
                    .load(t)
                    .then(function (e) {
                      o.addFile(e);
                    })
                    .catch(function (e) {
                      console.log(e);
                    })
                    .then(function () {}),
                    c(this).val(null);
                });
              },
            });
          var r = n(9),
            p = function (e) {
              var n = this,
                o = new r.Spinner({
                  className: "spinnerx",
                });
              (n.spin = function (e, t) {
                return (
                  (function (e, t) {
                    var n = document.createElement("div");
                    for (n.innerHTML = t; 0 < n.children.length; ) e.appendChild(n.children[0]);
                  })(
                    e,
                    "<div class='ProgressBG' style='z-index: 99999; position: absolute; top:0; left:0; right:0; bottom:0; background-color: rgba(247, 251, 255, " +
                      (t ? "1" : "0.8") +
                      ")" +
                      (document.getElementById("page")
                        ? document.getElementById("page").clientHeight > 0
                          ? ";height: " + document.getElementById("page").clientHeight + "px"
                          : ""
                        : "") +
                      "'></div>"
                  ),
                  o.spin(e),
                  n
                );
              }),
                (n.stop = function () {
                  c(o.el.parentElement).find(".ProgressBG").remove(), o.stop();
                });
            },
            h = 0;
          (d.bindingHandlers.component = {
            init: function (a, t, e, n, s) {
              function u() {
                var e = l && l.dispose;
                "function" == typeof e && e.call(l), (c = null);
              }
              var l,
                c,
                f = (function (e) {
                  for (var t = [], n = 0, o = e.length; n < o; n++) t.push(e[n]);
                  return t;
                })(d.virtualElements.childNodes(a));
              return (
                d.utils.domNodeDisposal.addDisposeCallback(a, u),
                d.computed(
                  function () {
                    var o,
                      r,
                      e = d.utils.unwrapObservable(t());
                    if (
                      ("string" == typeof e
                        ? (o = e)
                        : ((o = d.utils.unwrapObservable(e.name)), (r = d.utils.unwrapObservable(e.params))),
                      !o)
                    )
                      throw new Error("No component name specified");
                    var i = (c = ++h);
                    d.components.get(o, function (e) {
                      if (c === i) {
                        if ((u(), !e)) throw new Error("Unknown component '" + o + "'");
                        !(function (e, t, n) {
                          var o = t.template;
                          if (!o) throw new Error("Component '" + e + "' has no template");
                          var r = (function (e, t) {
                            for (var n = 0, o = e.length, r = []; n < o; n++) {
                              var i = e[n].cloneNode(!0);
                              r.push(t ? d.cleanNode(i) : i);
                            }
                            return r;
                          })(o);
                          d.virtualElements.setDomNodeChildren(n, r);
                        })(o, e, a);
                        try {
                          var t = (function (e, t, n, o) {
                              var r = e.createViewModel;
                              return r
                                ? r.call(e, o, {
                                    element: t,
                                    templateNodes: n,
                                  })
                                : o;
                            })(e, a, f, r),
                            n = new p().spin(a, !0);
                          Promise.resolve(t)
                            .then(function (t) {
                              var e = s.createChildContext(t, void 0, function (e) {
                                (e.$component = t), (e.$componentTemplateNodes = f);
                              });
                              ((l = t).viewElement = a), d.applyBindingsToDescendants(e, a);
                            })
                            .catch(function (e) {
                              console.error(e);
                            })
                            .then(function () {
                              n.stop();
                            });
                        } catch (e) {
                          console.error(e, "custom component binding error");
                        }
                      }
                    });
                  },
                  null,
                  {
                    disposeWhenNodeIsRemoved: a,
                  }
                ),
                {
                  controlsDescendantBindings: !0,
                }
              );
            },
          }),
            (d.virtualElements.allowedBindings.component = !0);
          var f = function (i, a, s, u) {
              return new (s = s || Promise)(function (e, t) {
                function n(e) {
                  try {
                    r(u.next(e));
                  } catch (e) {
                    t(e);
                  }
                }

                function o(e) {
                  try {
                    r(u.throw(e));
                  } catch (e) {
                    t(e);
                  }
                }

                function r(t) {
                  t.done
                    ? e(t.value)
                    : new s(function (e) {
                        e(t.value);
                      }).then(n, o);
                }
                r((u = u.apply(i, a || [])).next());
              });
            },
            m = function (n, o) {
              var r,
                i,
                a,
                e,
                s = {
                  label: 0,
                  sent: function () {
                    if (1 & a[0]) throw a[1];
                    return a[1];
                  },
                  trys: [],
                  ops: [],
                };
              return (
                (e = {
                  next: t(0),
                  throw: t(1),
                  return: t(2),
                }),
                "function" == typeof Symbol &&
                  (e[Symbol.iterator] = function () {
                    return this;
                  }),
                e
              );

              function t(t) {
                return function (e) {
                  return (function (t) {
                    if (r) throw new TypeError("Generator is already executing.");
                    for (; s; )
                      try {
                        if (
                          ((r = 1),
                          i &&
                            (a = 2 & t[0] ? i.return : t[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) &&
                            !(a = a.call(i, t[1])).done)
                        )
                          return a;
                        switch (((i = 0), a && (t = [2 & t[0], a.value]), t[0])) {
                          case 0:
                          case 1:
                            a = t;
                            break;
                          case 4:
                            return (
                              s.label++,
                              {
                                value: t[1],
                                done: !1,
                              }
                            );
                          case 5:
                            s.label++, (i = t[1]), (t = [0]);
                            continue;
                          case 7:
                            (t = s.ops.pop()), s.trys.pop();
                            continue;
                          default:
                            if (!(a = 0 < (a = s.trys).length && a[a.length - 1]) && (6 === t[0] || 2 === t[0])) {
                              s = 0;
                              continue;
                            }
                            if (3 === t[0] && (!a || (t[1] > a[0] && t[1] < a[3]))) {
                              s.label = t[1];
                              break;
                            }
                            if (6 === t[0] && s.label < a[1]) {
                              (s.label = a[1]), (a = t);
                              break;
                            }
                            if (a && s.label < a[2]) {
                              (s.label = a[2]), s.ops.push(t);
                              break;
                            }
                            a[2] && s.ops.pop(), s.trys.pop();
                            continue;
                        }
                        t = o.call(n, s);
                      } catch (e) {
                        (t = [6, e]), (i = 0);
                      } finally {
                        r = a = 0;
                      }
                    if (5 & t[0]) throw t[1];
                    return {
                      value: t[0] ? t[1] : void 0,
                      done: !0,
                    };
                  })([t, e]);
                };
              }
            };
          d.components.loaders.unshift({
            loadComponent: function (u, e, t) {
              "function" == typeof e
                ? e(function (s) {
                    s.__esModule && s.default && (s = s.default),
                      null != s.viewModel.prototype.activate
                        ? t({
                            createViewModel: function (i, a) {
                              return f(this, void 0, void 0, function () {
                                var t = this;
                                return m(this, function (e) {
                                  return [
                                    2,
                                    new Promise(function (o, r) {
                                      return f(t, void 0, void 0, function () {
                                        var t, n;
                                        return m(this, function (e) {
                                          (t = new s.viewModel(i, a)).viewElement = a.element;
                                          try {
                                            (n = new p().spin(t.viewElement, !0)),
                                              t
                                                .activate()
                                                .then(function () {
                                                  console.log("Activated " + u), o(t);
                                                })
                                                .catch(function (e) {
                                                  console.error(e), r(e);
                                                })
                                                .then(function () {
                                                  n.stop();
                                                });
                                          } catch (e) {
                                            console.error(e, "webpack-component-loader try catch"), r(e);
                                          }
                                          return [2];
                                        });
                                      });
                                    }),
                                  ];
                                });
                              });
                            },
                            template: d.utils.parseHtmlFragment(s.template),
                          })
                        : d.components.defaultLoader.loadComponent(u, s, t);
                  })
                : t(null);
            },
          });
          var o = "YYYY-MM-DD HH:mm";

          function i() {}
          var s,
            v,
            g,
            b,
            y = new ((i.formattedDateTimeObservable = function (n) {
              return d.pureComputed({
                read: function () {
                  if (n()) return u(n()).format(o);
                },
                write: function (e) {
                  if ("" == e) n(null);
                  else {
                    var t = u(e, o);
                    n(t);
                  }
                },
                deferEvaluation: !0,
              });
            }),
            (i.formattedDateObservable = function (n) {
              return d.pureComputed({
                read: function () {
                  if (n()) return u(n()).format(o);
                },
                write: function (e) {
                  if ("" == e) n(null);
                  else {
                    var t = u(e, o);
                    n(t);
                  }
                },
                deferEvaluation: !0,
              });
            }),
            (i.formattedTimeObservable = function (n) {
              return d.pureComputed({
                read: function () {
                  if (n()) return u(n()).format(o);
                },
                write: function (e) {
                  if ("" == e) n(null);
                  else {
                    var t = u(e, o);
                    n(t);
                  }
                },
                deferEvaluation: !0,
              });
            }),
            (i.hasValidationErrorsObservable = function (t) {
              function e() {
                var e = 0 < t.entityAspect.getValidationErrors().length;
                n() === e ? n.valueHasMutated() : n(e);
              }
              var n = d.observable(!1);
              return e(), t.entityAspect.validationErrorsChanged.subscribe(e), n;
            }),
            i)(),
            w = n(4),
            T = n(3),
            k = n(10),
            C = n(11),
            A = n(12),
            x = n(5),
            O = (0, k.createBrowserHistory)();
          ((v = s = s || {})[(v.userLoggedOff = 0)] = "userLoggedOff"),
            (v[(v.userLoggedOn = 1)] = "userLoggedOn"),
            (v[(v.userLoaded = 2)] = "userLoaded"),
            (v[(v.connectionChanged = 3)] = "connectionChanged"),
            (v[(v.WindowFormatChanged = 4)] = "WindowFormatChanged"),
            (v[(v.SignalRConnected = 5)] = "SignalRConnected"),
            (v[(v.SignalRDisconnected = 6)] = "SignalRDisconnected"),
            (v[(v.splitSizesChanged = 7)] = "splitSizesChanged"),
            (v[(v.AccessRightsUpdated = 8)] = "AccessRightsUpdated"),
            (v[(v.PasswordWillExpire = 9)] = "PasswordWillExpire"),
            (v[(v.ShowAttachmentDialogue = 10)] = "ShowAttachmentDialogue"),
            (v[(v.ShowConfirmMessage = 11)] = "ShowConfirmMessage"),
            ((b = g = g || {})[(b.Phone = 0)] = "Phone"),
            (b[(b.Mobile = 1)] = "Mobile"),
            (b[(b.Large = 2)] = "Large");

          function _() {
            var t = this;
            (this.mergeFromJS = function (e) {
              d.fromJS(t, e);
            }),
              (this.loadRelation = function (e, t, n, o) {
                if (e[n]) {
                  if (!n) throw "Relationship entity '" + n + "' needs to be defined in entities.ts.";
                  if (Array.isArray(e[n]))
                    return d.observableArray(
                      d.utils.arrayMap(e[n], function (e) {
                        return new t(e);
                      })
                    );
                  var r = new t(e[n]);
                  return "array" == o ? d.observableArray([r]) : d.observable(r);
                }
                return "array" == o ? d.observableArray() : d.observable(null);
              }),
              (this.formatJSONDate = function (e) {
                return null == e ? null : u.utc(e).toDate();
              });
          }
          var E = new (function () {
              var t = this;

              function e(e) {
                document.body.clientWidth < 450 &&
                  t.windowFormat() != g.Phone &&
                  (t.windowFormat(g.Phone), t.signals[s.WindowFormatChanged].dispatch(), console.log("phone")),
                  450 <= document.body.clientWidth &&
                    document.body.clientWidth < 992 &&
                    t.windowFormat() != g.Mobile &&
                    (t.windowFormat(g.Mobile), t.signals[s.WindowFormatChanged].dispatch(), console.log("mobile")),
                  992 <= document.body.clientWidth &&
                    t.windowFormat() != g.Large &&
                    (t.windowFormat(g.Large), t.signals[s.WindowFormatChanged].dispatch(), console.log("large"));
              }
              (this.updateMenu = function () {
                var e = localStorage.getItem("AccessRights");

                if (e) {
                  const accessRightsData = JSON.parse(e);

                  let menuItems = [];
                  if (accessRightsData && accessRightsData.AccessRights) {
                    menuItems = accessRightsData.AccessRights.map(function (ac) {
                      return new T.access_right(ac);
                    });
                  }

                  t.menu(menuItems);
                }
              }),
                (this.spin = function (e) {
                  return new p().spin(e || c("#page")[0]);
                }),
                (this.clearspin = function (e) {
                  e.stop();
                }),
                (this.scrollTop = function () {
                  Object(A.setTimeout)(function () {
                    window.scrollTo(0, 0);
                  }, 0);
                }),
                (this.scrollto = function (e) {
                  var t = document.getElementById(e);
                  t && t.scrollIntoView();
                }),
                (this.updateSigninStatus = function (e) {
                  t.signedIn(e),
                    e
                      ? (t.signals[s.SignalRConnected].dispatch(),
                        t.history.push(document.location.pathname),
                        t.signals[s.SignalRDisconnected].dispatch())
                      : t.history.push("/login");
                }),
                (this.navigate = function (e) {
                  console.log(x.join(t.base_path(), e)), t.history.push(x.join(t.base_path(), e));
                }),
                (this.apiURL = d.observable()),
                (this.PortalType = d.observable()),
                (this.productImageURL = d.observable()),
                (this.showOidcLog = d.observable(!1)),
                (this.oidcconfig = d.observable()),
                (this.base_path = d.observable("/")),
                (this.signedIn = d.observable(!1)),
                (this.environment = d.observable("")),
                (this.isConnected = d.observable(!1)),
                (this.menu = d.observableArray()),
                (this.history = O),
                (this.signals = Object.keys(s).map(function (e) {
                  return new C.Signal();
                })),
                (this.windowFormat = d.observable()),
                (window.onresize = e)(),
                this.signals[s.SignalRConnected].add(function () {
                  t.isConnected(!0);
                }),
                this.signals[s.SignalRDisconnected].add(function () {
                  t.isConnected(!1);
                }),
                this.updateMenu(),
                this.signals[s.AccessRightsUpdated].add(function () {
                  t.updateMenu();
                }),
                (this.progress = new p());
            })(),
            M = n(13),
            S =
              Object.assign ||
              function (e) {
                for (var t, n = 1, o = arguments.length; n < o; n++)
                  for (var r in (t = arguments[n])) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                return e;
              },
            j =
              (n(8),
              (F.prototype.dispose = function () {
                this.disposeHistory();
              }),
              F);

          function F(r, e) {
            var n = this;
            this.currentRoute = d.observable({});
            var o = M;
            o.removeAllRoutes(),
              o.resetState(),
              (o.normalizeFn = o.NORM_AS_OBJECT),
              e.forEach(function (t) {
                o.addRoute(E.base_path() + t.url, function (e) {
                  n.currentRoute(S({}, e, t.params));
                });
              }),
              (this.disposeHistory = r.listen(function (e) {
                return o.parse(e.pathname);
              })),
              c(document).on("click", "a", function (e) {
                var t = e.currentTarget;
                if (t && "A" === t.tagName && "_blank" != t.target) {
                  var n = t.getAttribute("href"),
                    o = t.getAttribute("target");
                  n &&
                    "/" == n.charAt(0) &&
                    "_blank" != o &&
                    ((n = n.replace("/", E.base_path())), r.push(n), e.preventDefault());
                }
              }),
              o.parse(r.location.pathname);
          }
          var L = function i() {
            var a = this;
            (this.isAvailable = function (e) {
              return 0 < a.get(e).length;
            }),
              (this.getLookup = function (t) {
                return w.find(a.lookups(), function (e) {
                  return e.name == t;
                });
              }),
              (this.get = function (e, t, n) {
                var o = a.getLookup(e);
                if (o) {
                  var r = o.isGlobalCode ? "code_value" : o.name.toLowerCase();
                  return t
                    ? w.filter(o.list(), function (e) {
                        if (!n) return 0 <= e[r]().indexOf(t);
                        switch (n) {
                          case i.FilterTypes.startsWith:
                            return e[r]().startsWith(t);
                          case i.FilterTypes.equals:
                            return e[r]() == t;
                        }
                      })
                    : o.list();
                }
                return [];
              }),
              (this.getLookupItemDescription = function (e, t) {
                if (!t) return null;
                var n = a.get(e, t, i.FilterTypes.equals);
                return 0 < n.length ? n[0].description() : "";
              }),
              (this.getByFieldFilter = function (e, t, n) {
                var o = a.getLookup(e);
                return o
                  ? w.filter(o.list(), function (e) {
                      return e[t]() == n;
                    })
                  : [];
              }),
              (this.add = function (e) {
                var t = a.getLookup(name);
                t ? (t = e) : a.lookups.push(e);
              }),
              (this.lookups = d.observableArray()),
              (this.lookupNames = d.pureComputed(function () {
                return w.map(a.lookups(), function (e) {
                  return e.name;
                });
              }));
          };
          !(function (e) {
            var t;
            ((t = e.FilterTypes || (e.FilterTypes = {}))[(t.startsWith = 1)] = "startsWith"),
              (t[(t.contains = 2)] = "contains"),
              (t[(t.equals = 3)] = "equals");

            function n(e, t, n) {
              if (((this.name = e), (this.isGlobalCode = t.hasOwnProperty("global_code_table")), "" == n))
                this.list = d.observableArray(t);
              else {
                n = n || e;
                var o = this.isGlobalCode ? "global_code_table" : n.toLowerCase();
                this.list = T.loadEntities(t, o);
              }
            }
            (e.Lookup = n), (e.lookupStorage = new e());
          })((L = L || {}));

          function D() {}
          var P,
            I,
            q =
              (((P =
                Object.setPrototypeOf ||
                ({
                  __proto__: [],
                } instanceof Array &&
                  function (e, t) {
                    e.__proto__ = t;
                  }) ||
                function (e, t) {
                  for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
                }),
              function (e, t) {
                function n() {
                  this.constructor = e;
                }
                P(e, t), (e.prototype = null === t ? Object.create(t) : ((n.prototype = t.prototype), new n()));
              })(R, (I = D)),
              R);

          function R() {
            var t = I.call(this) || this;
            return (
              (t.loadRelation = function (e, t, n) {
                if (e[t]) {
                  if (!T[t]) throw "Relationship entity '" + t + "' needs to be defined in entities.ts.";
                  if (Array.isArray(e[t]))
                    return d.observableArray(
                      d.utils.arrayMap(e[t], function (e) {
                        return new T[t](e);
                      })
                    );
                  var o = new T[t](e[t]);
                  return "array" == n ? d.observableArray([o]) : d.observable(o);
                }
                return "array" == n ? d.observableArray() : d.observable(null);
              }),
              (t.loadEntities = function (e, t) {
                if (e[t]) {
                  if (!T[t]) throw "Entity '" + t + "' needs to be defined in entities.ts.";
                  return Array.isArray(e[t])
                    ? d.observableArray(
                        d.utils.arrayMap(e[t], function (e) {
                          return new T[t](e);
                        })
                      )
                    : d.observable(new T[t](e[t]));
                }
                return d.observableArray();
              }),
              w.each(Object.keys(T), function (e) {
                t[e] = T[e];
              }),
              t
            );
          }
          var N = new q(),
            H =
              (n(8),
              window.APPSETTINGS,
              new (function () {
                this.getEnvironment = function () {
                  return new Promise(function (t, n) {
                    $.get(E.apiURL() + "api/access/GetEnvironment")
                      .done(function (e) {
                        t(e);
                      })
                      .fail(function (e) {
                        n(e);
                      });
                  });
                };
              })());
          n.d(t, "CustomObservables", function () {
            return y;
          }),
            n.d(t, "system", function () {
              return E;
            }),
            n.d(t, "Signal", function () {
              return s;
            }),
            n.d(t, "WindowFormat", function () {
              return g;
            }),
            n.d(t, "entityBase", function () {
              return _;
            }),
            n.d(t, "Router", function () {
              return j;
            }),
            n.d(t, "FileUpload", function () {
              return a;
            }),
            n.d(t, "LookupStorage", function () {
              return L;
            }),
            n.d(t, "entityManager", function () {
              return N;
            }),
            n.d(t, "EntityManager", function () {
              return q;
            }),
            n.d(t, "siteService", function () {
              return H;
            });
        },
      ]),
    (p.c = m),
    (p.d = function (e, t, n) {
      p.o(e, t) ||
        Object.defineProperty(e, t, {
          enumerable: !0,
          get: n,
        });
    }),
    (p.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module",
        }),
        Object.defineProperty(e, "__esModule", {
          value: !0,
        });
    }),
    (p.t = function (t, e) {
      if ((1 & e && (t = p(t)), 8 & e)) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (
        (p.r(n),
        Object.defineProperty(n, "default", {
          enumerable: !0,
          value: t,
        }),
        2 & e && "string" != typeof t)
      )
        for (var o in t)
          p.d(
            n,
            o,
            function (e) {
              return t[e];
            }.bind(null, o)
          );
      return n;
    }),
    (p.n = function (e) {
      var t =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return p.d(t, "a", t), t;
    }),
    (p.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (p.p = ""),
    p((p.s = 16))
  );

  function p(e) {
    if (m[e]) return m[e].exports;
    var t = (m[e] = {
      i: e,
      l: !1,
      exports: {},
    });
    return h[e].call(t.exports, t, t.exports, p), (t.l = !0), t.exports;
  }
  var h, m;
});
